
const config = {
   API_KEY: '8ec87ed72e16b484b9e552233c13f9dd',
   API_URL: 'https://api.themoviedb.org/3'
};

export default config;